// extracted by mini-css-extract-plugin
module.exports = {"root":"pages_root__1n3JT","column":"pages_column__3GPCI","input":"pages_input__1m_O4","invalid":"pages_invalid__1mgAy","features":"pages_features__1m_NK"};